/**
 * Welches Geburtsdatum in die Mails zur Probestunde gehört (Alter des Schülers).
 *
 * Das des gewählten Schülerprofils. Das des Kunden nur, wenn er selbst der Schüler
 * ist (Profil 1 oder noch keins gewählt) — sonst nannte die Mail an die Lehrkraft zum
 * Namen des Kindes das Alter der Mutter (T-0275).
 */
export function geburtsdatumFuerMail(
  profilGeburtsdatum: string | null | undefined,
  profilId: string | null | undefined,
  kundenGeburtsdatum: string | null | undefined,
): string {
  if (profilGeburtsdatum) return profilGeburtsdatum;
  const istKunde = !profilId || String(profilId).endsWith('-1');
  return istKunde ? kundenGeburtsdatum || '' : '';
}
